export default __webpack_public_path__ + "static/media/company-icon-logo.08b6e384.svg";